function firstString(...values) {
  return values.map((value) => String(value || "").trim()).find(Boolean) || "";
}

function isVideoType(value = "") {
  const type = String(value || "").trim().toLowerCase();
  return type === "video" || type.startsWith("video/");
}

function isLikelyVideoUrl(value = "") {
  const url = String(value || "").trim().toLowerCase();
  if (!url) return false;
  try {
    const pathname = new URL(url, "https://inssa.us").pathname.toLowerCase();
    return /\.(mp4|mov|m4v|webm|avi|mkv)$/i.test(pathname);
  } catch {
    return /\.(mp4|mov|m4v|webm|avi|mkv)(?:[?#]|$)/i.test(url);
  }
}

function getMediaType(item = {}) {
  if (typeof item === "string") {
    return isLikelyVideoUrl(item) ? "video" : "";
  }
  return firstString(item?.type, item?.contentType, item?.mimeType);
}

function getPreviewUrl(item = {}) {
  if (!item || typeof item === "string") return "";
  return firstString(
    item?.thumbnailUrl,
    item?.posterUrl,
    item?.previewUrl,
    item?.sessionPreviewUrl,
    item?.imageUrl
  );
}

function getImageUrl(item = {}) {
  if (!item) return "";
  if (typeof item === "string") {
    return isLikelyVideoUrl(item) ? "" : firstString(item);
  }

  const mediaType = getMediaType(item);
  const previewUrl = getPreviewUrl(item);
  if (previewUrl) return previewUrl;
  if (isVideoType(mediaType)) return "";

  const url = firstString(item?.downloadURL, item?.url, item?.photoUrl);
  return isLikelyVideoUrl(url) ? "" : url;
}

export function resolveCapsuleThumbnailMedia(capsule = {}) {
  const explicitUrl = firstString(
    capsule?.heroImageUrl,
    capsule?.thumbnailUrl,
    capsule?.imageUrl,
    capsule?.image,
    capsule?.posterUrl
  );
  if (explicitUrl && !isLikelyVideoUrl(explicitUrl)) {
    return { url: explicitUrl, type: "image", sourceMediaType: "image" };
  }

  const mediaItems = [
    ...(Array.isArray(capsule?.media) ? capsule.media : []),
    ...(Array.isArray(capsule?.mediaFiles) ? capsule.mediaFiles : []),
    ...(Array.isArray(capsule?.mediaUrls) ? capsule.mediaUrls : []),
  ];

  let firstVideo = null;
  for (const item of mediaItems) {
    const mediaType = getMediaType(item);
    if (!firstVideo && (isVideoType(mediaType) || (typeof item === "string" && isLikelyVideoUrl(item)))) {
      firstVideo = item;
    }

    const imageUrl = getImageUrl(item);
    if (imageUrl) {
      return {
        url: imageUrl,
        type: "image",
        sourceMediaType: isVideoType(mediaType) ? "video" : "image",
      };
    }
  }

  if (firstVideo) {
    return { url: "", type: "video", sourceMediaType: "video" };
  }

  return { url: "", type: "", sourceMediaType: "" };
}
